export namespace HostnameConstants {
    export enum AppHostnameHdr {
        SYS_DEFAULT_TENANT = 'SYS_DEFAULT_TENANT',
        SYS_AKN_WEB_CP_COMMERCE_PUBLIC_KEY = 'SYS_AKN_WEB_CP_COMMERCE_PUBLIC_KEY',
        SYS_AKN_WEB_CP_COMMERCE_CMS_WEBSITE_HDR_GUID = 'SYS_AKN_WEB_CP_COMMERCE_CMS_WEBSITE_HDR_GUID'
    }
}